import React from 'react';

var AddCard = function AddCard() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "74",
    height: "46",
    viewBox: "0 0 74 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2319 0H11.5015C8.81454 0 6.68436 2.01315 6.68436 4.52394L6.66016 31.6676C6.66016 34.1783 8.81454 36.1915 11.5015 36.1915H35.3086C34.7936 34.7618 34.4683 33.2441 34.3626 31.6675H11.5015V18.0957H39.8598C42.9448 15.2882 47.0757 13.5718 51.6152 13.5718C52.7994 13.5718 53.9559 13.6886 55.0732 13.9112V4.52394C55.0732 2.01315 52.9188 0 50.2319 0ZM11.5015 9.04788H50.2319V4.52394H11.5015V9.04788ZM41.0248 20.1457C43.9546 17.2711 47.4847 15.8338 51.6152 15.8338C55.7457 15.8338 59.2757 17.2711 62.2055 20.1457C65.1353 23.0203 66.6002 26.4839 66.6002 30.5366C66.6002 34.5893 65.1353 38.0529 62.2055 40.9275C59.2757 43.8021 55.7457 45.2394 51.6152 45.2394C47.4847 45.2394 43.9546 43.8021 41.0248 40.9275C38.095 38.0529 36.6302 34.5893 36.6302 30.5366C36.6302 26.4839 38.095 23.0203 41.0248 20.1457ZM59.3238 32.021V29.0522H53.1281V22.9731H50.1023V29.0522H43.9065V32.021H50.1023V38.1H53.1281V32.021H59.3238Z",
    fill: "#005FB9"
  }));
};

export default AddCard;